import React from "react"
import DropDown from "./dropdown.component"
import BGImage from "./bg-image.component"
class Category extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      dropdownOpen: false,
    }
  }

  setDropdownState = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    })
  }

  render() {
    let { id, category, desc, bg, position, secondaryBg } = this.props.data
    const animationTime = this.props.animationTime

    return (
      <section className="category" order={id}>
        <div className="container">
          <div className="category__content">
            <div
              className={`category__wrapper ${
                position == "right" ? "category__wrapper--right" : ""
              }`}
            >
              <div
                className="category__bgImage"
                style={{
                  backgroundImage: `url("${bg}")`,
                }}
                onClick={this.setDropdownState}
                data-aos={`${
                  position === "right" ? "fade-right" : "fade-left"
                }`}
                data-aos-delay={animationTime}
              >
                <h1 className="category__heading">{category}</h1>
                {!this.state.dropdownOpen ? (
                  <p className="category__detail">{desc}</p>
                ) : (
                  ""
                )}
              </div>
              {this.state.dropdownOpen === true ? (
                <DropDown
                  data={this.props.data}
                  setDropdownState={this.setDropdownState}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        {secondaryBg !== undefined ? <BGImage {...secondaryBg} /> : ""}
      </section>
    )
  }
}

export default Category
